export const APOLLO_STARGATE_CONTEXT_ROOT: string = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
